import vuex from "vuex"
import vue from "vue"
import vapi from "vuex-rest-api"
vue.use(vuex);

const campo = new vapi({
    baseURL: `${process.env.VUE_APP_REST}/api/campo`
    ,
    state: {
        campos: [],
        campossecundary: []
    }
}).get({
    action: "get_camposestado",
    path: function (obj) {
        return `/tabla/${obj.idtabla}/${obj.idestado}`;
    }, 
    onSuccess: (state, payload ) => {
        state.campos = payload.data;
    }
}).get({
    action: "get_camposestadosecundary",
    path: function (obj) {
        return `/tabla/${obj.idtabla}/${obj.idestado}`;
    }, 
    onSuccess: (state, payload ) => {
        state.campossecundary = payload.data;
    }
}).getStore();

campo.getters = {
    gcampos: state => {
        return state.campos
    },
    gcampossecundary: state => {
        return state.campossecundary
    }
}

export default campo;